import { render, staticRenderFns } from "./MailsDrawer.vue?vue&type=template&id=2b0450de&scoped=true"
import script from "./MailsDrawer.vue?vue&type=script&lang=js"
export * from "./MailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./MailsDrawer.vue?vue&type=style&index=0&id=2b0450de&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0450de",
  null
  
)

export default component.exports